import { connect, ConnectedProps } from 'react-redux';
import { selectCanAddPaymentMethod, selectFreeText } from '../../../../selectors/appState';
import { IStoreState } from '../../../../types/StoreState';
import { EmptyView } from './view';

const mapStateToProps = (state: IStoreState) => ({
  freeText: selectFreeText(state),
  canAddPaymentMethod: selectCanAddPaymentMethod(state),
});

const connector = connect(mapStateToProps);

export type IEmptyViewConnectedProps = ConnectedProps<typeof connector>;
export const EmptyViewConnect = connector(EmptyView);
